import React from 'react';
import { makeStyles, Box, Typography } from '@material-ui/core';
import facebookIcon from '../assets/AppBar/Facebook.png';
import instagramIcon from '../assets/AppBar/insta.png';

export default function TabsNavigation({ activeTab, onTabChange }) {
  const classes = useStyles();

  const tabs = [
    {
      id: 'facebook',
      label: 'Facebook',
      color: '#007BFF',
      icon: facebookIcon
    },
    {
      id: 'instagram',
      label: 'Instagram',
      gradient: 'linear-gradient(45deg, #f09433 0%,#e6683c 25%,#dc2743 50%,#cc2366 75%,#bc1888 100%)',
      color: '#e6683c',
      icon: instagramIcon
    }
  ];

  return (
    <Box className={classes.root}>
      <Box className={classes.tabsContainer}>
        {tabs.map((tab) => (
          <Box
            key={tab.id}
            className={`${classes.tab} ${activeTab === tab.id ? classes.activeTab : classes.inactiveTab}`}
            onClick={() => onTabChange(tab.id)}
            style={{
              borderBottomColor: activeTab === tab.id ? tab.color : 'transparent'
            }}
          >
            <img
              src={tab.icon}
              alt={`${tab.label} icon`}
              className={`${classes.icon} ${activeTab === tab.id ? classes.activeIcon : ''}`}
            />
            <Typography
              className={`${classes.tabText} ${activeTab === tab.id ? classes.activeText : classes.inactiveText}`}
              style={{
                color: activeTab === tab.id ? tab.color : '#707070',
                background: activeTab === tab.id && tab.gradient ? tab.gradient : 'inherit',
                WebkitBackgroundClip: activeTab === tab.id && tab.gradient ? 'text' : 'inherit',
                WebkitTextFillColor: activeTab === tab.id && tab.gradient ? 'transparent' : 'inherit'
              }}
            >
              {tab.label}
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
  tabsContainer: {
    display: 'flex',
    backgroundColor: '#FFFFFF',
    borderRadius: 12,
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
    maxWidth: 820,
    width: '92vw',
    position: 'relative',
  },
  tab: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1.5, 3),
    cursor: 'pointer',
    borderRadius: 8,
    transition: 'all 0.3s ease-in-out',
    borderBottom: '3px solid transparent',
    position: 'relative',
    minHeight: 48,
    gap: theme.spacing(1),
    '&:hover': {
      backgroundColor: 'rgba(0,0,0,0.02)',
    },
    [theme.breakpoints.down('sm')]: {
      padding: theme.spacing(1.2, 1.5),
      minHeight: 44,
    }
  },
  activeTab: {
    backgroundColor: 'rgba(0,123,255,0.05)',
    borderBottomWidth: 3,
    borderBottomStyle: 'solid',
    '&:hover': {
      backgroundColor: 'rgba(0,123,255,0.08)',
    }
  },
  inactiveTab: {
    '&:hover': {
      '& $tabText': {
        color: '#444444 !important',
      },
      '& $icon': {
        opacity: 0.8,
      }
    }
  },
  icon: {
    width: 16,
    height: 16,
    objectFit: 'contain',
    transition: 'all 0.3s ease-in-out',
    opacity: 0.7,
    [theme.breakpoints.down('sm')]: {
      width: 14,
      height: 14,
    }
  },
  tabText: {
    fontFamily: 'Karla, sans-serif',
    fontSize: 16,
    fontWeight: 500,
    textTransform: 'none',
    transition: 'all 0.3s ease-in-out',
    lineHeight: 1.2,
    [theme.breakpoints.down('sm')]: {
      fontSize: 14,
    }
  },
  activeText: {
    fontWeight: 700,
  },
  inactiveText: {
    color: '#707070',
    fontWeight: 500,
  },
  activeIcon: {
    opacity: 1,
    filter: 'brightness(1.1)',
  }
}));